<script>
import Banner from '../../components/banner'
export default {
    name: "detail",
    data() {
        return {
            detail: null
        };
    },
    computed: {},
    components: {
        Banner
    },
    mounted() {
        this.$store.dispatch('getDetail', {
            id: this.$route.query.id
        }).then((result) => {
            this.detail = result;
        }).catch((err) => {
            
        });
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="detail" v-if="detail">
        <Banner position="top left" :image="detail.banner" :title="detail.name" :desc="detail.banner_desc"/>
        <div class="wrapper layout_main flex flex_column">
            <div class="content">
                <p class="title">At a Glance</p>
                <div class="list_group flex justify_between">
                    <div class="list flex flex_column">
                        <div class="item" v-if="detail.title">
                            <p class="name">Course Title</p>
                            <p class="desc">{{ detail.title }}</p>
                        </div>
                        <div class="item" v-if="detail.type">
                            <p class="name">Course Type</p>
                            <p class="desc">{{ detail.type }}</p>
                        </div>
                        <div class="item" v-if="detail.credits">
                            <p class="name">Course Credits</p>
                            <p class="desc">{{ detail.credits }}</p>
                        </div>
                        <div class="item" v-if="detail.level">
                            <p class="name">Course Level</p>
                            <p class="desc">{{ detail.level }}</p>
                        </div>
                    </div>
                    <div class="list flex flex_column">
                        <div class="item" v-if="detail.method">
                            <p class="name">Study Method</p>
                            <p class="desc">{{ detail.method }}</p>
                        </div>
                        <div class="item" v-if="detail.date">
                            <p class="name">Start Date</p>
                            <p class="desc">{{ detail.date }}</p>
                        </div>
                    </div>
                    <div class="list flex flex_column">
                        <div class="item" v-if="detail.awarded">
                            <p class="name">Awarded & Delivered By</p>
                            <p class="desc">{{ detail.awarded }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content" v-if="detail.desc">
                <p class="title">Course Description</p>
                <div class="text" v-html="detail.desc"></div>
            </div>
            <div class="content" v-if="detail.content">
                <p class="title">Course Content</p>
                <div class="text" v-html="detail.content"></div>
            </div>
        </div>
        <div class="fees">
            <div class="layout_main">
                <div class="content flex align_center">
                    <p class="title">Course Fees</p>
                    <div class="text">
                        <p>Please Get in touch with us to get the most up-to-date course fee for this program.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrapper layout_main flex flex_column" v-if="detail.requrement">
            <div class="content">
                <p class="title">Entry Requrement</p>
                <!-- <div class="text">
                    <p class="li">A Postgraduate (Level 7) Diploma in Strategic Management and Leadership or equivalent.</p>
                    <p class="li">Applicants without a Level 7 Diploma but holding significant managerial experience will be considered for Advanced Entry on a case-by-case basis.</p>
                    <p class="li">IELTS 6.5 or equivalent. If your first language is not English, you may need to provide evidence of your English language ability.</p>
                </div> -->
                <div class="text" v-html="detail.requrement"></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    padding: .8rem 0;
    gap: .8rem 0;
    font-size: .2rem;
    color: #666;
    @media only screen and (max-width: 750px) {
        font-size: .24rem;
    }
}
.title{
    font-size: .56rem;
    font-weight: bold;
    margin-bottom: .2rem;
    color: var(--color);
    @media only screen and (max-width: 750px) {
        font-size: .4rem;
        margin-bottom: .4rem;
    }
}
.list_group{
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        gap: .4rem 0;
    }
    .list{
        gap: .4rem 0;
        max-width: 4rem;
        @media only screen and (max-width: 750px) {
            max-width: none;
        }
        .name{
            font-size: .24rem;
            color: var(--color-blue);
            margin-bottom: .15rem;
            // white-space: nowrap;
            @media only screen and (max-width: 750px) {
                font-size: .28rem;
                margin-bottom: .1rem;
            }
        }
    }
}
.blue{
    font-size: .24rem;
    color: var(--color-blue);
}
.text{
    line-height: 2;
    .li{
        display: flex;
        &::before{
            content: "·";
            font-size: .24rem;
            color: var(--color-blue);
            margin-right: .1rem;
            line-height: 1.5;
        }
    }
}
.fees{
    background: var(--background-color);
    color: #fff;
    font-size: .2rem;
    .content{
        height: 1.4rem;
        @media only screen and (max-width: 750px) {
            flex-direction: column;
            align-items: start;
            height: auto;
            padding: .3rem 0;
        }
    }
    .title{
        color: #fff;
        white-space: nowrap;
        margin-right: 1.2rem;
        margin-bottom: 0;
        @media only screen and (max-width: 750px) {
            margin-bottom: .4rem;
        }
    }
}
</style>